import React from "react";
import { Mail, Linkedin, Github, Download } from "lucide-react";
import PortfolioPageShell from "../components/portfolio/PortfolioPageShell";

function XIcon({ size = 20, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={style}
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

const CONTACTS = [
  {
    label: "Email",
    value: "vikramdev261@gmail.com",
    href: "mailto:vikramdev261@gmail.com",
    icon: Mail,
    shadow: "5px 5px 0 0 #4ADE80",
    accent: "#15803D",
  },
  {
    label: "X",
    value: "x.com/heyvikramdev",
    href: "https://x.com/heyvikramdev",
    icon: XIcon,
    shadow: "5px 5px 0 0 #F472B6",
    accent: "#BE185D",
    external: true,
  },
  {
    label: "LinkedIn",
    value: "linkedin.com/in/vikram-dev",
    href: "https://www.linkedin.com/in/vikram-dev",
    icon: Linkedin,
    shadow: "5px 5px 0 0 #A78BFA",
    accent: "#7E22CE",
    external: true,
  },
  {
    label: "GitHub",
    value: "github.com/vtensor",
    href: "https://github.com/vtensor",
    icon: Github,
    shadow: "5px 5px 0 0 #FB923C",
    accent: "#B45309",
    external: true,
  },
];

export default function PortfolioContact() {
  return (
    <PortfolioPageShell
      tag="CONTACT"
      title="GET IN TOUCH"
      subtitle="Let's build the good stuff"
      description="Open to full-time roles and serious collaborations in agentic AI, LLM infrastructure, and production ML."
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8">
        {CONTACTS.map((c) => {
          const Icon = c.icon;
          const linkProps = c.external
            ? { target: "_blank", rel: "noopener noreferrer" }
            : {};
          return (
            <a
              key={c.label}
              href={c.href}
              {...linkProps}
              className="group bg-white border-[3px] border-[#0A0A0A] p-5 flex items-center gap-4 transition-transform duration-150 hover:-translate-y-1"
              style={{ boxShadow: c.shadow }}
            >
              <div
                className="w-12 h-12 border-2 border-[#0A0A0A] flex items-center justify-center shrink-0"
                style={{ backgroundColor: `${c.accent}15` }}
              >
                <Icon size={20} style={{ color: c.accent }} />
              </div>
              <div className="min-w-0">
                <p
                  className="font-arcade text-xs uppercase tracking-widest mb-1"
                  style={{ color: c.accent }}
                >
                  {c.label}
                </p>
                <p className="font-terminal text-sm md:text-base text-[#0A0A0A] truncate">
                  {c.value}
                </p>
              </div>
            </a>
          );
        })}
      </div>

      <div className="flex flex-wrap gap-3">
        <a
          href="mailto:vikramdev261@gmail.com"
          className="inline-flex items-center gap-2 bg-[#4ADE80] text-black font-arcade text-base uppercase px-5 py-2.5 border-2 border-[#0A0A0A] hover:bg-[#15803D] hover:text-white transition-colors duration-150 btn-press"
        >
          <Mail size={14} /> SEND EMAIL
        </a>
        <a
          href="https://drive.google.com/file/d/1c8MRr1XpnrARn_92-7aDtOqgb3TWj0SF/view?usp=share_link"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-transparent text-[#0A0A0A] font-arcade text-base uppercase px-5 py-2.5 border-2 border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors duration-150 btn-press"
        >
          <Download size={14} /> RESUME
        </a>
      </div>
    </PortfolioPageShell>
  );
}
